import { Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { ServiceSpecialistRecordWorkTypeModalStore } from './service-specialist-record-work-type-modal.store';
import { Validators } from '@angular/forms';
import { isInvalid } from '../../../../../shared/helpers/validate';
import {
    ServiceSpecialistRecordWorkTypeObject,
} from '@libs/types/src/services/object-type/service/settings/service-specialist-record-work-type.object';
import {
    ServiceSpecialistRecordWorkTypeUpdateInput,
} from '@libs/types/src/services/input-type/services/settings/service-specialist-record-work-type.update-input';
import {
    ServiceSpecialistRecordWorkTypeCreateInput,
} from '@libs/types/src/services/input-type/services/settings/service-specialist-record-work-type.create-input';
import { contentGlobalSuccess } from '../../../../content.error';
import { fb, routeParams } from '../../../../../shared/shared.global-service';
import { Dialog } from '@openng/optimus-ui/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { CheckInputComponent } from '../../../../../../components/kit/input/check-input/check-input.component';
import { TextInputComponent } from '../../../../../../components/kit/input/text-input/text-input.component';
import { ActionButtonsComponent } from '../../../../../../components/kit/action-buttons/action-buttons.component';

@Component({
    selector: 'app-service-specialist-record-work-type-modal',
    templateUrl: 'service-specialist-record-work-type-modal.component.html',
    styleUrl: 'service-specialist-record-work-type-modal.component.scss',
    providers: [ServiceSpecialistRecordWorkTypeModalStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        Dialog,
        TranslatePipe,
        CheckInputComponent,
        TextInputComponent,
        ActionButtonsComponent,
    ],
})
export class ServiceSpecialistRecordWorkTypeModalComponent {
    protected readonly store = inject(ServiceSpecialistRecordWorkTypeModalStore);


    @Input() item: ServiceSpecialistRecordWorkTypeObject | null = null;

    protected visible = false;

    protected form = fb.group({
        active: fb.control<boolean>(true),
        name: fb.control<string>('', Validators.required),
        description: fb.control<string>(''),
    });

    public show(visible: boolean = true, item: ServiceSpecialistRecordWorkTypeObject | null = null): void {
        this.visible = visible;
        this.item = item;
        if (item) {
            this.form.patchValue(item);
        }
    }

    protected async submit(): Promise<void> {
        if (isInvalid(this.form)) return;


        if (!this.item && routeParams.serviceId()) {
            const serviceId = Number(routeParams.serviceId());
            this.store.api.createServiceSpecialistRecordWorkType({
                serviceId,
                ...this.form.value,
            } as ServiceSpecialistRecordWorkTypeCreateInput)
                .then(() => contentGlobalSuccess.next('common.created'));
        } else if (this.item) {
            this.store.api.updateServiceSpecialistRecordWorkType({
                id: this.item.id,
                ...this.form.value,
            } as ServiceSpecialistRecordWorkTypeUpdateInput)
                .then(() => contentGlobalSuccess.next('common.updated'));
        }

        this.show(false);
    }

}
